import { Pipe, PipeTransform } from '@angular/core';
import { NumberFormatter } from '../format/number-formatter';
import { CurrencyPipe, formatCurrency } from '@angular/common';

@Pipe({
  name: 'insolcurrency',
})
export class InsolCurrencyPipe implements PipeTransform {
  constructor(private numberFormatter: NumberFormatter) {}

  transform(value: number, showCents: boolean = true, excludeCurrencySymbol: boolean = false): string {
    return this.numberFormatter.formatCurrency(value, showCents, excludeCurrencySymbol);
  }
}
